import { registerComponent, Component, Entity, Object3DSetEvent } from "aframe";
import { Object3D } from "three";


interface Object3DComponent extends Component
{
	locationPending? : string;
	data : string;
	object3D : Object3D; //The original one
	setObject(obj : Object3D) : void;
}

const changeEl = (obj : Object3D & { el? : Entity, originEl? : Entity }, previousEl : Entity, newEl? : Entity ) =>
{
	if(obj.el && (obj.el !== previousEl) && (obj.originEl !== previousEl))
		return;

	obj.originEl = previousEl; //Mark obj as "taken from another Entity"
	obj.el = newEl;
	for(let child of obj.children)
		changeEl(child, previousEl, newEl);
}

registerComponent("object3d", {
	
	schema : { type : "string" },
	
	init(this: Object3DComponent)
	{
		this.locationPending = "Waiting to attach to object3D";
		this.object3D = this.el.object3D;
		this.object3D.visible = false; // this.object3D is not meant to exist.
		const parentEl = this.el.parentEl;
		if(parentEl)
			parentEl.addEventListener("object3dset", (event) => (event.target === parentEl) && this.update(null) );
	},
	
	update(this : Object3DComponent)
	{
		if(this.el.object3D.name && (this.el.object3D.name  == this.data))
		{
			//Already linked to the good object : is it still in the scene ? 

			const sceneObj = this.el.sceneEl!.object3D;
			for(let obj = this.el.object3D; obj; obj = obj.parent as any)
				if(obj === sceneObj)
					return;

		}

		const parentEl = this.el.parentEl;

		let obj : Object3D & { el? : Entity } | undefined = undefined;
		if(parentEl)
		{
			for(let child of parentEl.object3D.children)
			{
				const childEl = (child as Object3D & { el?:Entity}).el;
				if(childEl && (childEl.object3D === child) && (childEl.parentEl === parentEl))
					continue; // Ignore siblings

				//const child : Object3D & { el? : Entity } = parentEl.object3DMap[key];
				obj = (child.name == this.data) ? child : child.getObjectByName(this.data);
				if(obj)
					break;
			}
		}

		if( !obj )
			obj = this.object3D;

		if(obj === this.el.object3D) return; //No change.

		changeEl(this.el.object3D, this.el, undefined); //No longer mine
		changeEl(obj, obj.el!, this.el); //Now mine
		this.setObject(obj);
	},

	setObject(this : Object3DComponent, obj : Object3D)
	{
		const oldObj = this.el.object3D;

		this.el.object3D = obj;

		// DOM children that are still children of oldObj :
		for(let childEl = this.el.firstElementChild; childEl; childEl = childEl.nextElementSibling)
		{
			const childObj = (childEl as Entity).object3D;
			if(childObj && (childObj.parent === oldObj))
				obj.add(childObj);
		}
			
		// object3DMap :
		for(let key in this.el.object3DMap)
			obj.add( this.el.object3DMap[key] );

		// Some Entities might have attached to this.el (like items in a slot). Attach them too.
		for(let childObj of oldObj.children )
		{
			const childEl = (childObj as Object3D & { el? : Entity }).el;
			if(childEl && (childEl.parentEl === this.el))
				obj.add(childEl.object3D);
		}

		for(let key in this.el.components)
		{
			const c = this.el.components[key] as Component & 
			{
				attrValue : any;
				oldData : any;
				updateProperties(value: any, clobber?: boolean) : void;
			};
			if(((c as Component) !== this) && c.initialized)
				c.update(c.oldData);
				//c.updateProperties(c.attrValue, true);
				//c.update(c.data);
		}

		if( obj === this.object3D ) //Back to Entity.object3d => child of Entity.parentEL.object3d
			this.el.parentEl!.object3D.add(obj);
		else //Don't leave dead objects in parentEl
			this.object3D.removeFromParent();
			
		this.el.emit("object3dset", { type : null, object : obj });

		if( obj !== this.object3D ) // Yay!
		{
			delete this.locationPending;
			this.el.emit("location-initialized", this, false );
		}
	}
});
